import { render, staticRenderFns } from "./SimpleUserDashboard.vue?vue&type=template&id=da4731f2&scoped=true&"
import script from "./SimpleUserDashboard.vue?vue&type=script&lang=js&"
export * from "./SimpleUserDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUserDashboard.vue?vue&type=style&index=0&id=da4731f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4731f2",
  null
  
)

export default component.exports